var Trial;
(function (Trial) {
    var Controller = (function () {
        function Controller() {
            this.errorValidation = new ErrrorValidation.Controller();
            var _this = this;
            $('#submitCreateTrial').click(function () {
                helperController.AjaxHelper('CreateTrial', 'json', $('#createTrialForm').serialize(), 'POST',
                    function success(data) {
                        if (data) {
                            _this.errorValidation.SuccessShowHide('inactive', 'active');
                        } else {
                            _this.errorValidation.FailedShowHide('inactive', 'active');
                        }
                        _this.errorValidation.SuccessShowHide('inactive', 'active');
                    },
                    function failed(data) {
                        _this.errorValidation.FailedShowHide('inactive', 'active');
                    });
            });
        }
        return Controller;
    })();
    Trial.Controller = Controller;
})(Trial || (Trial = {}));
$(function () {
    new Trial.Controller();
})